var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "post post-instagram",
      class: { "response-comment": _vm.responseComment },
    },
    [
      _c(
        "div",
        { staticClass: "detail-event-header no-border" },
        [
          _vm.currentPage
            ? _c("AvatarComponent", {
                attrs: {
                  typeNetwork: _vm.currentPage.network,
                  urlPicture: _vm.currentPage.avatar,
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "info" }, [
            _vm.currentPage
              ? _c("div", { staticClass: "namePage" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.currentPage.name) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "typeEvent" },
              [
                _c("p", { attrs: { html: "" } }, [
                  _vm._v(_vm._s(_vm.dateFormatPost(_vm.event.date * 1000))),
                ]),
                _vm.post
                  ? [
                      _vm.post.permalink
                        ? _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.post.permalink,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "scrollable" },
        [
          _vm.post == false
            ? [_vm._m(0)]
            : _vm.isLoading || !_vm.post || !Object.keys(_vm.post).length
            ? [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "container-content-comments loading-content" },
                  _vm._l(3, function (index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "container-comment" },
                      [
                        _c("div", { staticClass: "comment" }, [
                          _vm._m(2, true),
                          _c("div", { staticClass: "container-content" }, [
                            _c("div", { staticClass: "content" }, [
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s("w".repeat(5 + Math.random() * 3))
                                ),
                              ]),
                            ]),
                            _vm._m(3, true),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.post && Object.keys(_vm.post).length
            ? [
                _c("div", { staticClass: "container-content-post" }, [
                  _c("div", { staticClass: "content-post" }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _vm.post.media_type == "IMAGE" && _vm.post.media_url
                          ? [
                              _c(
                                "div",
                                { staticClass: "picture loading-content" },
                                [
                                  _c("img", {
                                    attrs: { src: _vm.post.media_url },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm.post.media_type == "VIDEO" && _vm.post.media_url
                          ? [
                              _c("div", { staticClass: "video" }, [
                                _c("video", {
                                  attrs: {
                                    controls: "",
                                    src: _vm.post.media_url,
                                  },
                                }),
                              ]),
                            ]
                          : _vm._e(),
                        _vm.post.media_type == "CAROUSEL_ALBUM"
                          ? [
                              _c(
                                "div",
                                { staticClass: "multi-media" },
                                [
                                  _c(
                                    "carousel",
                                    {
                                      attrs: {
                                        perPage: 1,
                                        adjustableHeight: true,
                                        centerMode: true,
                                      },
                                    },
                                    _vm._l(
                                      _vm.post.children.data,
                                      function (children) {
                                        return _c(
                                          "Slide",
                                          { key: children.id },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "icon-carousel",
                                                attrs: {
                                                  width: "120",
                                                  height: "120",
                                                  viewBox: "0 0 120 120",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M95.1 78.525V17.75C95.1 8.32498 87.625 0.849976 78.2 0.849976H17.75C8.32498 0.849976 0.849976 8.32498 0.849976 17.75V78.525C0.849976 87.95 8.32498 95.425 17.75 95.425H78.525C87.625 95.1 95.1 87.625 95.1 78.525ZM109.4 30.75V83.075C109.4 97.7 97.375 109.725 82.75 109.725H30.425C28.475 109.725 27.5 112 28.8 113.3C32.05 116.875 36.6 119.15 42.125 119.15H85.675C104.2 119.15 119.15 104.2 119.15 85.675V42.125C119.15 36.925 116.875 32.05 113.3 28.8C111.675 27.5 109.4 28.8 109.4 30.75Z",
                                                    fill: "white",
                                                  },
                                                }),
                                              ]
                                            ),
                                            children.media_url.split("/")[3] ==
                                              "v" ||
                                            children.media_url.split("/")[3] !==
                                              "o1"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: children.media_url,
                                                  },
                                                })
                                              : _c("video", {
                                                  attrs: {
                                                    src: "children.media_url",
                                                  },
                                                }),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.post.caption
                          ? _c("div", { staticClass: "text" }, [
                              _c("pre", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messagePostFormat(_vm.post.caption)
                                  ),
                                },
                              }),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "bar-action-container" }, [
                      _c("div", { staticClass: "btns-action" }, [
                        _c(
                          "div",
                          {
                            staticClass: "reaction",
                            class: [{ liked: _vm.liked }],
                            on: {
                              click: function ($event) {
                                return _vm.toggleLikePost(_vm.post.ig_id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-regular fa-heart" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.post.like_count
                                    ? _vm.getFormatNumber(_vm.post.like_count)
                                    : 0
                                ) +
                                " like" +
                                _vm._s(
                                  _vm.post.like_count && _vm.post.like_count > 1
                                    ? "s"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "comments",
                            on: {
                              click: function ($event) {
                                _vm.autoFocus = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-regular fa-comment" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.post.comments_count
                                    ? _vm.getFormatNumber(
                                        _vm.post.comments_count
                                      )
                                    : 0
                                ) +
                                " commentaire" +
                                _vm._s(
                                  _vm.post.comments_count &&
                                    _vm.post.comments_count > 1
                                    ? "s"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "container-content-comments" },
                  [
                    _vm.errorLoadOriginalComment
                      ? [
                          _c("div", { staticClass: "container-comment" }, [
                            _c("div", { staticClass: "comment" }, [
                              _vm._m(4),
                              _c("div", { staticClass: "container-content" }, [
                                _c("div", { staticClass: "content" }, [
                                  _c("p", { staticClass: "text" }, [
                                    _c("span", { staticClass: "name-user" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.event.data.changes &&
                                            _vm.event.data.changes.value &&
                                            _vm.event.data.changes.value.from &&
                                            _vm.event.data.changes.value.from
                                              .username
                                            ? _vm.event.data.changes.value.from
                                                .username
                                            : ""
                                        )
                                      ),
                                    ]),
                                    _c("br"),
                                    _vm._v("Commentaire indisponible"),
                                  ]),
                                  _c("div", { staticClass: "media" }),
                                ]),
                                _c("div", { staticClass: "info-content" }),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    "is_comment_enabled" in _vm.post &&
                    !_vm.post.is_comment_enabled
                      ? [
                          _c("p", { staticClass: "no-comment" }, [
                            _vm._v("Les commentaires sont désactivé"),
                          ]),
                        ]
                      : _vm.post.comments &&
                        _vm.post.comments.data &&
                        _vm.post.comments.data.length
                      ? [
                          _vm._l(
                            _vm.post.comments.data,
                            function (comment, indexComment) {
                              return _c(
                                "div",
                                {
                                  key: comment.id,
                                  staticClass: "container-comment",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "comment",
                                      class: {
                                        "has-response":
                                          comment.replies &&
                                          comment.replies.data &&
                                          comment.replies.data.length,
                                        hidden: comment.is_hidden,
                                      },
                                    },
                                    [
                                      _vm._m(5, true),
                                      _c(
                                        "div",
                                        { staticClass: "container-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _c("p", { staticClass: "text" }, [
                                                _c(
                                                  "span",
                                                  { staticClass: "name-user" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        comment.from &&
                                                          comment.from.username
                                                          ? comment.from
                                                              .username
                                                          : comment.username
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " + _vm._s(comment.text)
                                                ),
                                              ]),
                                              _c("div", {
                                                staticClass: "media",
                                              }),
                                              _c(
                                                "ContextMenu",
                                                {
                                                  attrs: {
                                                    options:
                                                      _vm.getOptionComment(
                                                        comment.id,
                                                        comment
                                                      ),
                                                    id: comment.id,
                                                  },
                                                  on: {
                                                    clickOption:
                                                      _vm.clickOptionComment,
                                                  },
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "btn-more",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "info-content" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "date" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.dateFormat(
                                                        comment.timestamp
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "action" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "answer",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.startResponseComment(
                                                            comment.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Répondre")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  comment.replies &&
                                  comment.replies.data &&
                                  comment.replies.data.length
                                    ? _vm._l(
                                        comment.replies.data,
                                        function (subComment, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "comment response",
                                              class: {
                                                hidden: subComment.is_hidden,
                                              },
                                            },
                                            [
                                              _vm._m(6, true),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "container-content",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "content" },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "text" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "name-user",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subComment.username ||
                                                                    subComment
                                                                      .from
                                                                      .username
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                subComment.text
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("div", {
                                                        staticClass: "media",
                                                      }),
                                                      _c(
                                                        "ContextMenu",
                                                        {
                                                          attrs: {
                                                            options:
                                                              _vm.getOptionComment(
                                                                subComment.id,
                                                                subComment
                                                              ),
                                                            id: subComment.id,
                                                          },
                                                          on: {
                                                            clickOption:
                                                              _vm.clickOptionComment,
                                                          },
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "btn-more",
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "date" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.dateFormat(
                                                                subComment.timestamp
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("div", {
                                                        staticClass: "action",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                  comment.replies &&
                                  comment.replies.paging &&
                                  comment.replies.paging.next
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "comment response end",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "container-content",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "more-comment",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.getNextResponseComment(
                                                              indexComment
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Voir plus réponses"
                                                        ),
                                                      ]
                                                    ),
                                                    comment.displayloaderNextComment
                                                      ? _c("div", {
                                                          staticClass:
                                                            "util-loader",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }
                          ),
                          _vm.post.comments.paging &&
                          _vm.post.comments.paging.next
                            ? _c(
                                "span",
                                {
                                  staticClass: "more-comment",
                                  on: { click: _vm.getNextComment },
                                },
                                [
                                  _c("p", [
                                    _vm._v("Voir plus de commentaires"),
                                  ]),
                                  _vm.displayloaderNextComment
                                    ? _c("div", { staticClass: "util-loader" })
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm.post.comments_count && _vm.post.comments_count > 0
                      ? [
                          _c("p", { staticClass: "no-comment" }, [
                            _vm._v("Commentaire indisponible"),
                          ]),
                        ]
                      : [
                          _c("p", { staticClass: "no-comment" }, [
                            _vm._v("Aucun commentaire"),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("FormSendMessage", {
        attrs: { activeMedia: false, setAutofocus: _vm.autoFocus },
        on: {
          onSubmitMessage: _vm.sendComment,
          autoFocused: function ($event) {
            _vm.autoFocus = false
          },
        },
      }),
      _vm.responseComment
        ? _c("div", { staticClass: "container-response-comment" }, [
            _c("p", [
              _vm._v("Répondre à "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.getCommentById(_vm.responseComment)
                      ? _vm.getCommentById(_vm.responseComment).from.username
                      : "rien"
                  )
                ),
              ]),
            ]),
            _c("i", {
              staticClass: "fa-solid fa-circle-xmark",
              on: { click: _vm.stopResponseComment },
            }),
          ])
        : _vm._e(),
      _vm.privateMessageComment
        ? _c(
            "div",
            {
              staticClass:
                "container-response-comment container-private-message",
            },
            [
              _c("p", [
                _vm._v("Message privé à "),
                _c("span", [_vm._v(_vm._s(_vm.privateMessageComment.name))]),
              ]),
              _c("i", {
                staticClass: "fa-solid fa-circle-xmark",
                on: { click: _vm.stopPrivateMessage },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-none-post" }, [
      _c("div", { staticClass: "none-post" }, [
        _c("p", [_vm._v("Post non disponible")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "container-content-post loading-content" },
      [
        _c("div", { staticClass: "content-post" }, [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "picture" }),
          ]),
          _c("div", { staticClass: "bar-action-container" }, [
            _c("div", { staticClass: "btns-action" }, [
              _c("div", { staticClass: "reaction" }, [
                _c("i", { staticClass: "fa-regular fa-heart" }),
              ]),
              _c("div", { staticClass: "comments" }, [
                _c("i", { staticClass: "fa-regular fa-comment" }),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", {
        attrs: {
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-content" }, [
      _c("div", { staticClass: "date" }, [_vm._v("wwwwwwwww")]),
      _c("div", { staticClass: "action" }, [
        _c("div", { staticClass: "answer" }, [_vm._v("Répondre")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", { attrs: { src: "img/avatar.jpg" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", { attrs: { src: "img/avatar.jpg" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", { attrs: { src: "img/avatar.jpg" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }